<script>
import CommonTableComponent from "@/components/table.vue";
import number from "@/mixins/number";
import tableSearch from "@/mixins/tableSearch";
import DatePicker from "vue2-datepicker";
import dailyReportControlRules from "@/mixins/dailyReportControlRules";
import estimate from "@/mixins/estimate"

export default {
  name: "ServiceInput",
  components: {
    CommonTableComponent,
    DatePicker,
  },
  mixins: [number, tableSearch, dailyReportControlRules, estimate],
  props: {
    wasteOrServiceByDailyReport: {
      type: Object,
      required: true,
    },
    dailyReport: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      default: () => {},
    },
    indexWasteOrService: {
      type: Number,
      default: 0,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    controlRules: {
      type: Object|null,
    },
    canBeDelete: {
      type: Boolean,
      default: false,
    },
    isApproveSidePage: {
      type: Boolean,
      default: false
    },
    isMaintenanceSidePage:{
      type: Boolean,
      default: false,
    }
  },
  methods: {
    scheduleIdWithSubId(wasteOrService) {
      return [
        this.dailyReport.schedule_id,
        wasteOrService?.daily_report_sub_id,
      ].filter(x => !!x).join('-')
    },
    serviceName(wasteOrService) {
      let wasteOrServiceInJson = this.getTargetWasteOrServiceFromJson(wasteOrService.wastes_or_services_by_work_order_id);
      return wasteOrServiceInJson?.service?.name;
    },
    getProductNameByService(estimate) {
      return estimate.invoice_product_name;
    },
    getZzUnit(estimate) {
      return estimate.zz_unit?.unit;
    },
    getZzUnitBGColorClass(estimate) {
      return (estimate.zz_unit.id != '06');
    },
    deleteService() {
      this.$emit('deleteService', this.wasteOrServiceByDailyReport);
    },
    isDisplaied(item){
      if(item.type == "all") return true;
      if(item.type == "approve" && this.isApproveSidePage) return true;
      return false;
    },
    getUnitPrice(estimate){
      let end = this.$moment(this.dailyReport.schedule.end_datetime).format('YYYY-MM-DD');
      return this.getRecentUnitPrice(estimate, end);
    },
    getIsApproveSidePage(){
      return this.isApproveSidePage;
    },
    getTargetWasteOrServiceFromJson(targetId){
      return this.dailyReport.work_order_json.waste_or_service_by_work_order.find((item) => item.id == targetId);
    },
  },
  computed: {
    estimateHeaders() {
      return [
        {
          text: "見積明細番号",
          value: "estimate_cd",
          sortable: false,
          type: "all",
          additionalClasses:"estimate_cd",
        },
        {
          text: "請求書表示用商品名",
          value: "product_name",
          sortable: false,
          type: "all",
          additionalClasses:"product_name",
        },
        {
          text: "数量",
          value: "quantity",
          sortable: false,
          type: "all",
          additionalClasses:"quantity",
        },
        {
          text: "単位",
          value: "unit",
          sortable: false,
          type: "all",
          additionalClasses:"unit",
        },
        {
          text: "単価",
          value: "unit_price",
          sortable: false,
          type: "approve",
          additionalClasses:"unit_price",
        },
        {
          text: "空容器数量",
          value: "number_of_rental_containers",
          sortable: false,
          type: "all",
          additionalClasses:"number_of_rental_containers",
        },
      ];
    },
    isApproved() {
      // メンテナンスページであればすべて許可する
      if(this.isMaintenanceSidePage) return false;
      if (this.dailyReport.work_order_json.zz_work_order_type_id === this.$constant.work_order_type.transportation_disposal) {
        if (this.vendorSiteId) {
          return parseInt(this.wasteOrServiceByDailyReport.treatment_approved_status) === 1;
        }

        return parseInt(this.wasteOrServiceByDailyReport.transport_approved_status) === 1
      }
      return parseInt(this.wasteOrServiceByDailyReport.transport_approved_status) === 1
        || parseInt(this.wasteOrServiceByDailyReport.treatment_approved_status) === 1;
    },
    vendorSiteId() {
      return this.$route.query.vendor_site_id ?? null;
    },
  }
}
</script>

<template>
  <b-card>
    <b-row>
      <div class="d-flex justify-content-between">
        <div>
          <label class="me-3">受付番号-枝番</label>
          {{scheduleIdWithSubId(wasteOrServiceByDailyReport)}}
          <span v-if="isApproved">(承認済)</span>
        </div>
        <div
          v-if="canBeDelete"
        >
          <b-btn
            class="btn-custom-red"
            :disabled="isApproved"
            @click="deleteService"
          >
            <i class="fas fa-eraser"></i> 削除
          </b-btn>
        </div>
      </div>
    </b-row>
    <b-row class="mt-2">
      <b-col cols="5" v-if="isDisplayControl('waste_service_name')">
        <div>
          <label class="me-3">作業名称</label>
          {{serviceName(wasteOrServiceByDailyReport)}}
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-2" v-if="isDisplayControl('estimates')">
      <div class="custom-table gap-2">
        <div class="title">見積明細</div>
        <CommonTableComponent class="table-custom" :height-class="`table-wrapper-500`">
          <thead class="table-light">
          <tr>
            <template v-for="(item, index) in estimateHeaders">
            <th
              :class="getHeaderClass(item)"
               v-if="isDisplaied(item)"
            >
            <span>
              {{ item.text }}
              </span>
            </th>
          </template>
          </tr>
          </thead>
          <tbody>
          <tr
            v-for="(estimate, estimateIndex) in wasteOrServiceByDailyReport.estimates_by_daily_report"
            :key="`estimate_${wasteOrServiceByDailyReport.id}_${estimate.id}`"
          >
            <td>{{ estimate.estimate_cd }}</td>
            <td>{{ getProductNameByService(estimate) }}</td>
            <td>
              <b-form-input
                :disabled="isApproved"
                @keyup="setMinNumber($event)"
                type="number"
                v-model="estimate.quantity"
                min="0"
              ></b-form-input>
              <div
                v-if="errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.estimates_by_daily_report.${estimateIndex}.quantity`]"
                class="error-message"
              >
                {{ errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.estimates_by_daily_report.${estimateIndex}.quantity`][0] }}
              </div>
            </td>
            <td :class="{bg_notice:getZzUnitBGColorClass(estimate)}">
              {{getZzUnit(estimate)}}
            </td>
            <td v-if="getIsApproveSidePage()">
              {{getUnitPrice(estimate)}}
            </td>
            <td>
              <b-form-input
                class="input-field"
                :disabled="true"
                :value="estimate.number_of_rental_containers"
                type="text"
                maxLength="50"
              ></b-form-input>
            </td>
          </tr>
          <tr v-if="!wasteOrServiceByDailyReport.estimates_by_daily_report.length && !isLoading">
              <td colspan="6" class="text-center">
                  データなし。
              </td>
          </tr>
          </tbody>
        </CommonTableComponent>
      </div>
      <div
        v-if="errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.estimates_by_daily_report`]"
        class="error-message"
      >
        {{ errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.estimates_by_daily_report`][0] }}
      </div>
    </b-row>
  </b-card>
</template>

<style scoped lang="scss">
.estimate_cd{
  width:10%;
  min-width:100px;
}
        
.quantity{
  width:15%;
  min-width:100px;
}

.unit{
  width:10%;
  min-width:50px;

}
.unit_price{
  width:10%;
  min-width:70px;
}
.number_of_rental_containers{
  width:20%;
  min-width:100px;
}
.bg_notice{
  background-color: yellow;
}
</style>
